import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import PropertyPage from "./PropertyPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nekretnine/:slug" element={<PropertyPage />} />
      </Routes>
    </BrowserRouter>
  );
}
